export default __webpack_public_path__ + "static/media/Globe.635479ca.svg";